import { create } from "../../../../../common/utils/zustand_state_manager";
import { FuncionarioDropDown } from "../../../../../common/domain/models/funcionario_dropdown";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { SubcontaDropdown } from "../../../domain/models/subconta_dropdown";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { BancoPagamentoDropDown } from "../../../domain/models/banco_pagamento_dropdown";
import { FolhaPagamentoDropDown } from "../../../domain/models/folha_pagamento_dropdown";
import { FiltroFolhaPagamento } from "../../../domain/models/filtro_folha_pagamento";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";

/**
 * useFolhaPagamentoFilters
 */

type State = {
  tipoPesquisa: number;
  valorPesquisa: string | null;
  dataCadastro: Date | null;
  dataPagamento: Date | null;
  numero: string | null;
  idFuncionario: number | null;
  funcionarios: FuncionarioDropDown[] | undefined;
  subcontas: SubcontaDropdown[] | undefined;
  centroCustos: CentroCustoDropDown[] | undefined;
  folhaPagamentos: FolhaPagamentoDropDown[] | undefined;
  folhaPagamentoDetalhadas: FolhaPagamentoDropDown[] | undefined;
  bancoPagamentos: BancoPagamentoDropDown[] | undefined;
  cargos: CargoDropDown[] | undefined;
  filtroFolhaPagamento: FiltroFolhaPagamento | null | undefined;
};

type Actions = {
  setTipoPesquisa: SetFunction<number | null>;
  setValorPesquisa: SetFunction<string | null>;
  setDataCadastro: SetFunction<Date | null>;
  setDataPagamento: SetFunction<Date | null>;
  setNumero: SetFunction<string | null>;
  setIdFuncionario: SetFunction<number | null>;
  setFuncionarios: SetFunction<FuncionarioDropDown[] | undefined>;
  setSubcontas: SetFunction<SubcontaDropdown[] | null>;
  setCentroCustos: SetFunction<CentroCustoDropDown[] | null>;
  setFolhaPagamentos: SetFunction<FolhaPagamentoDropDown[] | null>;
  setFolhaPagamentoDetalhadas: SetFunction<FolhaPagamentoDropDown[] | null>;
  setBancoPagamentos: SetFunction<BancoPagamentoDropDown[] | null>;
  setCargos: SetFunction<CargoDropDown[] | null>;
  setFiltroFolhaPagamento: SetFunction<FiltroFolhaPagamento | undefined>;
  clear: () => void;
};

export const useFolhaPagamentoFilters = create<State & Actions>((set) => ({
  tipoPesquisa: 1,
  valorPesquisa: null,
  dataCadastro: null,
  dataPagamento: null,
  numero: null,
  idFuncionario: null,
  funcionarios: undefined,
  subcontas: undefined,
  centroCustos: undefined,
  folhaPagamentos: undefined,
  folhaPagamentoDetalhadas: undefined,
  bancoPagamentos: undefined,
  cargos: undefined,
  filtroFolhaPagamento: undefined,
  setTipoPesquisa: vfn => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setValorPesquisa: vfn => SetFunctionImpl(set, 'valorPesquisa', vfn),
  setDataCadastro: vfn => SetFunctionImpl(set, 'dataCadastro', vfn),
  setDataPagamento: vfn => SetFunctionImpl(set, 'dataPagamento', vfn),
  setNumero: vfn => SetFunctionImpl(set, 'numero', vfn),
  setIdFuncionario: vfn => SetFunctionImpl(set, 'idFuncionario', vfn),
  setFuncionarios: vfn => SetFunctionImpl(set, 'funcionarios', vfn),
  setSubcontas: vfn => SetFunctionImpl(set, 'subcontas', vfn),
  setCentroCustos: vfn => SetFunctionImpl(set, 'centroCustos', vfn),
  setFolhaPagamentos: vfn => SetFunctionImpl(set, 'folhaPagamentos', vfn),
  setFolhaPagamentoDetalhadas: vfn => SetFunctionImpl(set, 'folhaPagamentoDetalhadas', vfn),
  setBancoPagamentos: vfn => SetFunctionImpl(set, 'bancoPagamentos', vfn),
  setCargos: vfn => SetFunctionImpl(set, 'cargos', vfn),
  setFiltroFolhaPagamento: vfn => SetFunctionImpl(set, 'filtroFolhaPagamento', vfn),
  clear: () => set({
    tipoPesquisa: 1,
    valorPesquisa: null,
    dataCadastro: null,
    dataPagamento: null,
    numero: null,
    idFuncionario: null,
  }),
}));